import { DatePipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  APP_ROUTES_CONFIG,
  MeterSensorType,
  ParameterType,
} from '@contracts';
import { CommonService, DialogService, ModuleStore, ToastService } from '@core';
import { MeterService } from '@feature/meter';
import * as regular from '@fortawesome/free-regular-svg-icons';
import * as solid from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { MenuHeaderTopic } from '@ui';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { map, Observable, startWith, Subscription } from 'rxjs';
import { ExploreService } from './data-access/explore.service';
import { DEFALUT_PARAMETER_DATA } from '@feature/explore';
type Meter = { name: string; description?: string };
type BasePayload = {
  meter_name: any;
  parameter: string | string[] | null;
  module: string | null;
  compareBy?: 'meter' | 'parameter' | null;
};

type CustomPayload = BasePayload & {
  type: 'custom';
  start_time: string;
  end_time: string;
};

type PeriodPayload = BasePayload & {
  type: 'period';
  period: string;
};

type Payload = CustomPayload | PeriodPayload;
interface OptionSersor {
  value: string;
  viewValue: string;
  building: string;
  type: string;
}

interface Paiod {
  name: string;
  value: string;
}

@Component({
  selector: 'app-graph',
  templateUrl: './explore.component.html',
  styleUrl: './explore.component.scss',
})
export class ExploreComponent implements OnInit, OnDestroy {
  private sitename = inject(APP_ROUTES_CONFIG).siteName;

  selectedMetersCustom: any[] = [];
  selectedParametersCustom: any[] = [];

  selectedMetersPeriod: any[] = [];
  selectedParametersPeriod: any[] = [];
  compareListOption: {
    value: string;
    label: string;
  }[] = [
    {
      value: 'meter',
      label: 'view_value.meter',
    },
    {
      value: 'parameter',
      label: 'view_value.parameter',
    },
  ];

  graph: MenuHeaderTopic = {
    title: 'view_value.explore',
    subtitle: 'view_value.desc_graph_data',
    iconUrl: 'assets/shared/icons/chart-pie.svg',
  };

  setting: MenuHeaderTopic = {
    title: 'view_value.setting',
    subtitle: 'view_value.settings_details',
    iconUrl: 'assets/shared/icons/setting.svg',
  };

  iconsolid = solid;
  iconregular = regular;

  sensors: OptionSersor[] = [];
  type_sensor: any;
  building: any;
  meter: any;
  // parameters: string[] = ['kw']

  parameters_custom: ParameterType[] = [];
  // this.PARAMETER_INJECT ?? DEFALUT_PARAMETER_DATA;
  loadingData!: boolean;
  chartHidden!: boolean;
  chartOptions: any;
  dataGraph: any;
  dataExport: any;
  dataExport_custom: any;
  onDownload: boolean = false;
  onDownload_period: boolean = false;
  onDownload_custom: boolean = false;
  initOpts = {
    // height: 450
  };

  image = '';

  option: any[] = [];
  meterlistPeriod: any[] = [];
  meterlistCustom: any[] = [];
  parameterCtrl = new FormControl('');
  filteredParameters!: Observable<any[]>;
  filteredMeterOptions!: Observable<any[]>;

  location_list: any[] = [];
  compareCrl = new FormControl('meter');
  customForm = new FormGroup({
    sensor_type: new FormControl('energy'),
    compareBy: new FormControl<'meter' | 'parameter'>('meter'),
    meter_name: new FormControl<Meter[] | string | null>(null),
    parameter: new FormControl<any>(null),
    start_time: new FormControl(null, Validators.required),
    end_time: new FormControl(null, Validators.required),
  });

  periodForm = new FormGroup({
    sensor_type: new FormControl<'energy' | 'water'>('energy'),
    compareBy: new FormControl<'meter' | 'parameter'>('parameter'),
    meter_name: new FormControl<Meter | string | null>(null),
    parameter: new FormControl<any>({ value: 'kwh', disabled: true }),
    period: new FormControl(null, Validators.required),
  });

  filteredOptionsPeriod?: Observable<any[]>;

  filteredOptionsCustom?: Observable<any[]>;

  dataDetail: any;

  sensor_type_list = [
    'energy',
    // 'water'
  ];

  constructor(
    private exploreService: ExploreService,
    private commonService: CommonService,
    private meterService: MeterService,
    private datePipe: DatePipe,
    public dialog: DialogService,
    public toast: ToastService,
    private moduleStore: ModuleStore,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.call_api();
    this.loadParameter();

    this.filteredParameters = this.parameterCtrl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterParameter(value || '')),
    );

    this.customForm.get('compareBy')?.valueChanges.subscribe(() => {
      this.selectedMetersCustom = [];
      this.selectedParametersCustom = [];

      this.customForm.patchValue({
        meter_name: null,
        parameter: null,
      });
    });
    // this.periodForm.get('compareBy')?.valueChanges.subscribe((mode) => {
    //   this.selectedMeters = [];
    //   this.selectedParameters = [];

    //   this.periodForm.patchValue({
    //     meter_name: null,
    //     parameter: null,
    //   });
    // });
  }

  private filterMeters(keyword: string, meters: any[]): any[] {
    const filterValue = keyword.trim().toLowerCase();

    return meters.filter((meter) => {
      const name = String(meter.name ?? '').toLowerCase();
      const description = String(meter.description ?? '').toLowerCase();

      return name.includes(filterValue) || description.includes(filterValue);
    });
  }

  private loadParameter(): void {
    this.updateParameterControlState();
    this.updateFormState(this.customForm, [], [], true);

    this.updateFormState(this.periodForm, [], [], true);

    this.commonService.getParameter('ems').subscribe({
      next: (res) => {
        this.parameters_custom = res.meta.response_data ?? DEFALUT_PARAMETER_DATA;

        this.updateFormState(
          this.customForm,
          this.meterlistCustom,
          this.parameters_custom,
          false,
        );

        this.updateFormState(
          this.periodForm,
          this.meterlistPeriod,
          this.parameters_custom,
          false,
        );
        this.parameterCtrl.setValue(this.parameterCtrl.value ?? '');
      },
      error: (error) => {
        console.error(error);
        this.updateFormState(this.customForm, [], [], true);

        this.updateFormState(this.periodForm, [], [], true);
        this.parameters_custom = [];
        this.updateParameterControlState();
      },
    });
  }

  private _filterParameter(value: string): string[] {
    const filterValue = value.trim().toLowerCase();

    return this.parameters_custom.filter((option) => {
      const key = String(option).toLowerCase();

      const translatedValue = this.translate
        .instant(`view_value.${option}`)
        .toString()
        .toLowerCase();

      return key.includes(filterValue) || translatedValue.includes(filterValue);
    });
  }

  isSelectedParameter(option: any, type: 'custom' | 'period'): boolean {
    const selected =
      type === 'custom'
        ? this.selectedParametersCustom
        : this.selectedParametersPeriod;

    return selected.some((o) => o === option);
  }
  meterCtrl = new FormControl<string | Meter>('');

  // onSelectMeter(option: any) {
  //   if (this.compareBy === 'meter') {
  //     this.graphForm.get('meter_name')?.setValue(option);
  //   } else {
  //     const exists = this.selectedMeters.find((x) => x.name === option.name);
  //     if (!exists) this.selectedMeters.push(option);
  //   }
  // }
  private getForm(type: 'custom' | 'period') {
    return type === 'custom' ? this.customForm : this.periodForm;
  }
  removeMeter(item: any, type: 'custom' | 'period') {
    if (type === 'custom') {
      this.selectedMetersCustom = this.selectedMetersCustom.filter(
        (x) => x.name !== item.name,
      );

      this.customForm.controls.meter_name.setValue(
        this.selectedMetersCustom.map((v) => v.name),
      );
    } else {
      this.selectedMetersPeriod = this.selectedMetersPeriod.filter(
        (x) => x.name !== item.name,
      );

      this.periodForm.controls.meter_name.setValue(
        this.selectedMetersPeriod[0] ?? null,
      );
    }
  }

  toggleParameter(option: string, type: 'custom' | 'period'): void {
    const selected =
      type === 'custom'
        ? this.selectedParametersCustom
        : this.selectedParametersPeriod;

    const exists = selected.some((item) => item === option);

    const updated = exists
      ? selected.filter((item) => item !== option)
      : [...selected, option];

    if (type === 'custom') {
      this.selectedParametersCustom = updated;

      this.customForm.controls.parameter.setValue(updated);
    } else {
      this.selectedParametersPeriod = updated;

      this.periodForm.controls.parameter.setValue(updated);
    }

    this.parameterCtrl.setValue('');
  }

  removeParameter(item: any, type: 'custom' | 'period') {
    if (type === 'custom') {
      this.selectedParametersCustom = this.selectedParametersCustom.filter(
        (v) => v !== item,
      );

      this.customForm.controls.parameter.setValue(
        this.selectedParametersCustom.map((v) => v),
      );
    } else {
      this.selectedParametersPeriod = this.selectedParametersPeriod.filter(
        (v) => v !== item,
      );

      this.periodForm.controls.parameter.setValue(
        this.selectedParametersPeriod.map((v) => v),
      );
    }
  }

  preload_floor_Subscription!: Subscription;
  preload_panel_Subscription!: Subscription;

  custom_floor_Subscription!: Subscription;
  custom_panel_Subscription!: Subscription;

  ngOnDestroy(): void {
    this.preload_floor_Subscription?.unsubscribe();
    this.preload_panel_Subscription?.unsubscribe();
    this.custom_floor_Subscription?.unsubscribe();
    this.custom_panel_Subscription?.unsubscribe();
  }

  call_api() {
    this.loadMeterList().then((value: any) => {
      this.meterlistPeriod = value ?? [];
      this.meterlistCustom = value ?? [];

      this.filteredMeterOptions = this.meterCtrl.valueChanges.pipe(
        startWith(''),
        map((value) => {
          const keyword =
            typeof value === 'string' ? value : (value?.name ?? '');

          return keyword
            ? this.filterMeters(keyword, this.meterlistPeriod)
            : this.meterlistPeriod.slice();
        }),
      );

      this.update_parameter();
    });
  }

  isSelectedMeter(option: any, type: 'custom' | 'period'): boolean {
    const selected =
      type === 'custom' ? this.selectedMetersCustom : this.selectedMetersPeriod;

    return selected.some((o) => o.name === option.name);
  }

  toggleMeter(option: any, type: 'custom' | 'period') {
    const selectedMeters =
      type === 'custom' ? this.selectedMetersCustom : this.selectedMetersPeriod;

    const exists = selectedMeters.some((o) => o.name === option.name);

    const updated = exists
      ? selectedMeters.filter((o) => o.name !== option.name)
      : [...selectedMeters, option];

    if (type === 'custom') {
      this.selectedMetersCustom = updated;

      this.customForm.controls.meter_name.setValue(updated.map((v) => v.name));
    } else {
      this.selectedMetersPeriod = updated;

      this.periodForm.controls.meter_name.setValue(updated[0] ?? null);
    }

    this.meterCtrl.setValue('');
  }

  async loadMeterList(sensor_type?: MeterSensorType) {
    let data = await new Promise((resolve, reject) => {
      this.dialog
        .withLoading(
          this.meterService.getMeters({
            sensor_module: 'EMS',
            sensor_type: sensor_type ? sensor_type : 'energy',
          }),
        )
        .subscribe({
          next: (res) => {
            if (res.meta.response_code == 20000) {
              let data = <{ module: string }[]>res.meta.response_data;
              return resolve(data);
            } else {
              this.toast.error('Occurred');
              return reject();
            }
          },
          error: (e) => {
            console.error(e);
            this.toast.error(e.statusText);
            return reject();
          },
        });
    });
    return data;
  }

  update_parameter() {
    this.updateFormState(
      this.customForm,
      this.meterlistCustom,
      this.parameters_custom,
    );

    this.updateFormState(
      this.periodForm,
      this.meterlistPeriod,
      this.parameters_custom,
    );
    this.filteredOptionsPeriod =
      this.periodForm.controls.meter_name.valueChanges.pipe(
        startWith(''),
        map((value: any) => {
          const name = typeof value === 'string' ? value : value?.name;
          let data = this.meterlistPeriod;
          return name ? this._filterPeriod(name as string, data) : data.slice();
        }),
      );

    this.filteredOptionsCustom =
      this.customForm.controls.meter_name.valueChanges.pipe(
        startWith(''),
        map((value: any) => {
          const keyword =
            typeof value === 'string' ? value : (value?.name ?? '');

          return keyword
            ? this.filterMeters(keyword, this.meterlistCustom)
            : this.meterlistCustom.slice();
        }),
      );

    this.filteredOptionsPeriod =
      this.periodForm.controls.meter_name.valueChanges.pipe(
        startWith(''),
        map((value: any) => {
          const keyword =
            typeof value === 'string' ? value : (value?.name ?? '');

          return keyword
            ? this.filterMeters(keyword, this.meterlistPeriod)
            : this.meterlistPeriod.slice();
        }),
      );
  }

  zone!: string[];
  meter_period!: string[];
  period: Paiod[] = [
    {
      name: 'day',
      value: 'day',
    },
    {
      name: 'week',
      value: 'week',
    },
    {
      name: 'month',
      value: 'month',
    },
    {
      name: 'year',
      value: 'year',
    },
  ];
  responPublic: any;
  data_period_this!: any;
  data_period_last!: any;
  category_period!: any;
  period_selected!: any;

  zone_period_list: any[] = [];
  zone_custom_list: any[] = [];
  responview_value: any[] = [];

  zoneCheck(zoneInput: any) {
    const filteredZone = this.responview_value.filter(
      (location: { zone: any }) => location.zone === zoneInput,
    );
    let meter: any = [];
    filteredZone.forEach((value: any) => {
      meter.push(value.name);
    });
    this.meter = meter.sort();
  }

  createBarChart() {
    let period: any = this.period_selected;
    let datahead: any = {
      this:
        period == 'day'
          ? 'today'
          : period == 'week'
            ? 'this week'
            : period == 'month'
              ? 'this month'
              : period == 'year'
                ? 'this year'
                : 'today',
      last:
        period == 'day'
          ? 'yesterday'
          : period == 'week'
            ? 'last week'
            : period == 'month'
              ? 'last month'
              : period == 'year'
                ? 'last year'
                : 'today',
    };

    this.chartOptions = {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: 60,
        right: 50,
        bottom: 90,
      },
      legend: {
        data: [datahead.last, datahead.this],
        bottom: 0,
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          restore: { show: true },
          saveAsImage: {
            type: 'png',
            name: 'day on day',
          },
        },
      },
      calculable: true,
      dataZoom: [
        {
          type: 'inside',
        },
        {
          type: 'slider',
          bottom: 35,
        },
      ],
      xAxis: [
        {
          type: 'category',
          // prettier-ignore
          data: this.category_period,
        },
      ],
      yAxis: [
        {
          type: 'value',
          splitNumber: 2,
        },
      ],
      series: [
        {
          name: datahead.last,
          type: 'bar',
          data: this.data_period_last,
          color: '#4F6A95',
        },
        {
          name: datahead.this,
          type: 'bar',
          data: this.data_period_this,
          color: '#0A182E',
        },
      ],
    };
  }

  plug: string[] = [];

  onParameterSelected(value: any) {
    // this.parameter_selected.value = value
  }

  intervalSet: any;

  dialogRef: any;

  normalizeMeter = (value: any): string | string[] | null => {
    if (!value) return null;
    if (Array.isArray(value)) {
      return value.map((v) => (typeof v === 'string' ? v : v.name));
    }

    if (typeof value === 'object') {
      return value.name ?? null;
    }

    return value;
  };

  normalizeParameter(value: any): string | string[] | null {
    if (!value) return null;

    if (Array.isArray(value)) {
      return value;
    }

    return value;
  }

  onSubmit(type: 'custom' | 'period') {
    this.dataDetail = null;
    if (type === 'custom') {
      const form = this.customForm;

      if (!form.valid) return;

      const value = form.value;
      const payload: CustomPayload = {
        type: 'custom',
        module: this.moduleStore.module(),
        meter_name: this.normalizeMeter(value.meter_name),
        parameter: this.normalizeParameter(value.parameter),
        compareBy: value.compareBy ?? null,
        start_time: this.datePipe.transform(value.start_time, 'yyyy-MM-dd')!,
        end_time: this.datePipe.transform(value.end_time, 'yyyy-MM-dd')!,
      };

      this.callApi(payload, type);
    }

    if (type === 'period') {
      const form = this.periodForm;

      if (!form.valid) return;

      const value = form.getRawValue();

      const payload: PeriodPayload = {
        type: 'period',
        module: this.moduleStore.module(),

        meter_name:
          typeof value.meter_name === 'string'
            ? [value.meter_name]
            : value.meter_name?.name
              ? [value.meter_name.name]
              : null,
        parameter: value.parameter!,
        period: value.period!,
      };

      this.callApi(payload, type);
    }
  }

  private callApi(payload: Payload, type: 'custom' | 'period') {
    const api$ =
      payload.compareBy === 'meter'
        ? this.exploreService.getExploreByMeter(payload)
        : this.exploreService.getParameterExplore(payload);

    this.dialog.withLoading(api$).subscribe({
      next: (res) => {
        if (res.meta.response_code !== 20000) {
          this.toast.error('เกิดข้อผิดพลาด');
          return;
        }

        const { data, detail } = res.meta.response_data;

        if (type === 'period') {
          // this.dataGraph =
          //   payload.compareBy === 'meter'
          //     ? detail?.explore?.line_graph
          //     : detail?.explore?.bar_graph;
          this.dataGraph = detail?.explore?.bar_graph;

          this.dataExport = data.export;

          const format = (v: any) => {
            const num = Number(v);
            return isNaN(num) ? null : num.toFixed(3);
          };
          const dataset = this.dataGraph?.datasets?.[0];

          this.data_period_this = dataset?.this?.map(format);
          this.data_period_last = dataset?.last?.map(format);

          this.category_period =
            this.dataGraph?.labels ||
            detail.graph.hour ||
            detail.graph.day ||
            detail.graph.month;

          this.period_selected = detail.period;
          this.onDownload_period = true;

          this.createBarChart();
        }

        if (type === 'custom') {
          // this.dataGraph =
          //   payload.compareBy === 'meter'
          //     ? detail?.explore?.line_graph
          //     : detail?.explore?.bar_graph;

          this.dataGraph = detail?.explore?.line_graph;

          this.dataDetail = detail;
          this.dataExport_custom = data.export;
          this.onDownload_custom = true;

          this.chartOptions = this.buildLineChart(this.dataGraph);
        }

        if (!this.dataGraph) {
          this.toast.warning('view_value.no_data');
        }
      },
      error: (e) => {
        console.error(e);
        this.toast.error('เกิดข้อผิดพลาด');
      },
    });
  }

  private updateParameterControlState(): void {
    const disabled = this.parameters_custom.length === 0;

    if (disabled) {
      this.parameterCtrl.disable({ emitEvent: false });
    } else {
      this.parameterCtrl.enable({ emitEvent: false });
    }
  }

  private updateFormState(
    form: typeof this.customForm | typeof this.periodForm,
    meterData: any[],
    parameterData: any[],
    isLoading = false,
  ): void {
    const isReady =
      !isLoading && meterData.length > 0 && parameterData.length > 0;

    if (isReady) {
      form.enable({ emitEvent: false });
    } else {
      form.disable({ emitEvent: false });
    }

    // period parameter ถูกออกแบบให้ disabled อยู่แล้ว
    if (form === this.periodForm) {
      form.controls.parameter.disable({ emitEvent: false });
    }
  }
  get isCustomDisabled(): boolean {
    return (
      this.meterlistCustom.length === 0 || this.parameters_custom.length === 0
    );
  }

  get isPeriodDisabled(): boolean {
    return (
      this.meterlistPeriod.length === 0 || this.parameters_custom.length === 0
    );
  }
  private buildLineChart(data: any[]) {
    if (!data?.length) {
      return {};
    }

    return {
      legend: { bottom: 0 },
      grid: { left: 60, right: 50, bottom: 100 },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          animation: false,
          label: { backgroundColor: '#505765' },
        },
      },
      xAxis: {
        type: 'time',
        boundaryGap: false,
        splitLine: { show: false },
      },
      yAxis: {
        type: 'value',
        scale: true,
      },
      toolbox: {
        feature: {
          dataView: { show: true, readOnly: false },
          restore: { show: true },
          saveAsImage: { show: true },
        },
      },
      dataZoom: [
        { show: true, realtime: true, start: 0, end: 100, bottom: 40 },
        { type: 'inside', realtime: true, start: 30, end: 70 },
      ],
      series: data.map((v: any) => ({
        name: v.parameter || v.meter_name,
        type: 'line',
        symbol: 'none',
        data: v.datasets,
      })),
    };
  }

  floor_list: string[] = [];

  onExportCSV(meter: any, type: any, dataExport_csv: any) {
    try {
      let dataExport = dataExport_csv.map((v: any) => {
        if (type == 'custom') {
          return v;
        }
        return { ...v };
      });
      let dataExport_0_value = dataExport[0];
      let headers = Object.keys(dataExport_0_value);
      var options = {
        showLabels: true,
        headers: headers,
        useHeader: true,
      };
      const now = new Date();

      const datetime =
        now.getFullYear() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        '_' +
        String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0');

      new AngularCsv(
        dataExport,
        `ems_data_explore_export_${datetime}`,
        options,
      );
    } catch (error) {
      console.error(error);
      alert('Export Data Occurred');
    }
  }

  displayFn(meter: any): string {
    // show meter data filter by floor , zone
    return meter
      ? `${meter?.name}${meter.description ? ' | ' + meter.description : ''}`
      : '';
  }

  private _filterPeriod(name: string, data: any[]): any[] {
    // search period meter data
    const filterValue = name.toLowerCase();
    return data.filter((option) => {
      let name_check = `${option.name}`.toLowerCase().includes(filterValue);
      let shop_name_check = `${option.description}`
        .toLowerCase()
        .includes(filterValue);
      return name_check || shop_name_check;
    });
  }

  private _filterCustom(name: string, data: any[]): any[] {
    // search custom meter data
    const filterValue = name.toLowerCase();
    return data.filter((option) => {
      let name_check = `${option.name}`.toLowerCase().includes(filterValue);
      let shop_name_check = `${option.description}`
        .toLowerCase()
        .includes(filterValue);
      return name_check || shop_name_check;
    });
  }
}

let defalut_parameter_data_water: { value: string; view_value: string }[] = [
  { value: 'volume', view_value: 'Volume' },
];
